import anime from 'animejs';

import { calculateBreaksAndColors, changeLogoColor } from './logo';

const easing = 'cubicBezier(0.420, 0.000, 0.535, 0.995)';

const body = document.body;
const headerContainer = document.querySelector('.header__container');
const hamburgerBtn = document.querySelector('.header-hamburger__button');
const logoContainer = document.querySelector('.header-logo__container');
const logoSVG = document.querySelector('.header-logo__svg');
const hamburgerLineContainer = document.querySelector('.header-hamburger__line-container');
const nav = document.querySelector('.nav');
const menu = document.querySelector('#menu-main-menu');
const videos = document.querySelectorAll('.nav__video'); // just the node list
const videoArr = Array.from(videos);
const menuItems = document.querySelectorAll('#menu-main-menu .menu-item');
const menuItemsArr = Array.from(menuItems);
const menuLinks = document.querySelectorAll('#menu-main-menu .menu-item a');
const menuLinksArr = Array.from(menuLinks);
const contactLink = document.querySelector("a[href='#contact']");
const defaultNavVideo = document.querySelector('.nav__video:not(.nav__video-hidden)');
const defaultVideoSlug = defaultNavVideo ? defaultNavVideo.getAttribute('data-video-slug') : null;
const barbaWrapper = document.querySelector('.barba-wrapper');
let currentVideoSlug = defaultVideoSlug;
let currentPageItem; // will be re-assigned on initial page load and on Barba enter hooks

//
// MENU BEHAVIOR, including toggling, link highlighting
//
const openMenu = () => {
    nav.style.display = 'flex';
    const isMobile = window.innerWidth <= 600;
    const logoIsInverted = document.querySelector('.header-logo__svg--inverse') !== null;
    const scaleX = thirdLineScale(window.innerWidth);
    const defaultVideo = document.querySelector('.nav__video--default');
    const scrollbarWidth = getScrollbarWidth();

    if (defaultVideo && !isMobile) {
        defaultVideo.play();
    }

    if (logoIsInverted) {
        logoSVG.classList.remove('header-logo__svg--inverse');
        hamburgerLineContainer.classList.remove('header-hamburger__line-container--inverse');
    }
    // this conditional stops the header from "jumping" when the scrollbar disappears
    if (!isMobile && document.body.offsetHeight > window.innerHeight) {
        headerContainer.style.width = `calc(100% - ${scrollbarWidth}px)`;
        barbaWrapper.style.marginRight = `${scrollbarWidth}px`;
    }
    anime({
        targets: '.header-hamburger__line--mover',
        scaleX,
        duration: 300,
        easing
    });
    anime({
        targets: '.nav',
        translateX: '0%',
        duration: 300,
        easing
    });
    anime({
        targets: '.header-hamburger__page-name',
        opacity: 0,
        translateY: -50,
        duration: 200,
        easing: 'linear'
    });
    body.style.overflow = 'hidden'; // lock scrolling
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', keyboardControls);
    if (currentPageItem) {
        currentPageItem.addEventListener('click', currentPageClick);
        currentPageItem.addEventListener('touchstart', currentPageClick);
    }
};

// exported for use in other partials (namely, barba.js)
export const closeMenu = (useAnimation = true) => {
    let isMobile = window.innerWidth <= 600;

    // this conditional stops the header from "jumping" when the scrollbar disappears
    if (!isMobile && document.body.offsetHeight > window.innerHeight) {
        headerContainer.style.width = '100%';
        barbaWrapper.style.marginRight = '0px';
    }

    if (useAnimation) {
        anime({
            targets: '.header-hamburger__line--mover',
            scaleX: 1,
            duration: 300,
            easing
        });
        anime({
            targets: '.nav',
            translateX: '100%',
            duration: 300,
            easing,
            complete: resetMenuState
        });
        anime({
            targets: '.header-hamburger__page-name',
            opacity: 1,
            translateY: 0,
            duration: 200,
            easing: 'linear'
        });
    } else {
        // This moves the menu back to its original position on the right
        // without showing an animation (used for page transitions, which
        // displays a different menu animation).
        anime({
            targets: '.nav',
            translateX: '100%',
            duration: 0,
            complete: resetMenuState
        });
    }
    body.style.overflow = ''; // unlock scrolling
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', keyboardControls);
    if (currentPageItem) {
        currentPageItem.removeEventListener('click', currentPageClick);
        currentPageItem.removeEventListener('touchstart', currentPageClick);
    }
    calculateBreaksAndColors();
    changeLogoColor();
};

const toggleMenu = () => {
    let expanded = hamburgerBtn.getAttribute('aria-expanded') === 'true' || false;

    if (!expanded) {
        openMenu();
    } else {
        closeMenu();
    }
};

const keyboardControls = (e) => {
    const selectedIndex = menuLinksArr.indexOf(document.activeElement);
    const numOfItems = menuLinksArr.length;
    if (e.keyCode === 27) {
        // ESC KEY
        closeMenu();
        hamburgerBtn.focus();
    } else if (e.keyCode === 40) {
        // DOWN KEY
        if (selectedIndex > numOfItems - 2) {
            menuLinksArr[0].focus();
        } else {
            menuLinksArr[selectedIndex + 1].focus();
        }
    } else if (e.keyCode === 38) {
        // UP KEY
        if (selectedIndex === -1) {
            // close menu if hamburger is focused
            if (document.activeElement === hamburgerBtn) {
                closeMenu();
            } else {
                // otherwise focus on the first menu item
                menuLinksArr[0].focus();
            }
        } else if (selectedIndex === 0) {
            menuLinksArr[numOfItems - 1].focus();
        } else {
            menuLinksArr[selectedIndex - 1].focus();
        }
    }
};

// prevents a re-load when the link to the current page is clicked
const currentPageClick = (e) => {
    e.preventDefault();
    closeMenu();
};

// This determines the "currentPageItem" variable, which is ultimately responsible
// for menu behavior when the user clicks a link to the page they are already on.
export const determineCurrentPage = () => {
    const menuItemWithActive = document.querySelector('.menu-item.active');
    if (menuItemWithActive) {
        currentPageItem = menuItemWithActive;
    } else if (window.location.pathname === '/') {
        // if homepage, clicking the logo should just close the menu
        currentPageItem = logoContainer;
    } else {
        currentPageItem = null;
    }

    // change page name next to the hamburger menu
    const pageName = document.querySelector('.barba-container').getAttribute('data-page-name');
    document.querySelector('.header-hamburger__page-name').innerHTML = pageName;
};

// Removes highlighting on last hovered link, goes back to default video, re-assigns
// the ".active" class if necessary. Called when menu close animation completes.
const resetMenuState = () => {
    const currentPageURL = currentPageItem ? currentPageItem.querySelector('a').href : null;
    videoArr.map((item) => item.classList.add('nav__video--hidden'));
    menuLinksArr.map((item) => item.classList.remove('highlighted'));
    if (defaultNavVideo) {
        defaultNavVideo.classList.remove('nav__video--hidden');
    }
    currentVideoSlug = defaultVideoSlug;
    nav.style.display = 'none';

    // changes the location of the ".active" class on the menu's <li> if a user is on a new page
    if (window.location.href !== currentPageURL) {
        menuItemsArr.map((item) => item.classList.remove('active'));
        const newCurrentLink = menuItemsArr.filter((item) => {
            const itemLink = item.querySelector('a');
            return itemLink.href === window.location.href;
        })[0];
        if (newCurrentLink) {
            newCurrentLink.classList.add('active');
        }
    }

    // "rewind" all the videos
    if (videoArr.length > 0) {
        videoArr.map((video) => {
            video.pause();
            video.currentTime = 0;
        });
    }
};

const thirdLineScale = (width) => {
    // leftOffset is the X value position the third line eventually needs to go to
    let leftOffset;
    const navContainer = document.querySelector('.nav__container');
    const navContStyles = window.getComputedStyle(navContainer);
    if (width > 900) {
        // desktop
        const navEl = document.querySelector('.nav');
        const navStyles = window.getComputedStyle(navEl);
        const navXPos = (parseInt(navStyles.width, 0) - parseInt(navContStyles.width, 0)) / 2;
        const movieContainer = document.querySelector('.nav__movie-container');
        const movieStyles = window.getComputedStyle(movieContainer);
        leftOffset =
            parseInt(navContStyles.marginLeft, 0) +
            parseInt(navContStyles.paddingLeft, 0) +
            parseInt(movieStyles.width, 0) +
            parseInt(movieStyles.marginRight, 0) +
            navXPos;
    } else {
        // tablet and below
        leftOffset = parseInt(navContStyles.marginLeft, 0) + parseInt(navContStyles.paddingLeft, 0);
    }

    // rightOffset is the distance away the right-most edge of the third line is from the edge of the screen
    const movingLine = document.querySelector('.header-hamburger__line--mover');
    const headerContainer = document.querySelector('.header__container');
    const lineStyles = window.getComputedStyle(movingLine);
    const containerStyles = window.getComputedStyle(headerContainer);
    const rightOffset =
        parseInt(lineStyles.marginRight, 10) + parseInt(containerStyles.paddingRight, 10);

    const initialLineWidth = parseInt(lineStyles.width, 10);
    const targetedLineWidth = width - (leftOffset + rightOffset);

    return targetedLineWidth / initialLineWidth;
};

const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
};

hamburgerBtn.addEventListener('click', () => {
    toggleMenu();
});

if (contactLink) {
    contactLink.addEventListener('click', () => {
        closeMenu();
    });
}

//
// MENU VIDEOS
//
const changeVideo = (e) => {
    const newVideoSlug = e.target.getAttribute('data-video-slug');
    // only fire events if a new Vimeo ID is selected
    if (newVideoSlug && newVideoSlug !== currentVideoSlug) {
        const oldVideo = videoArr.filter((item) => item.dataset.videoSlug === currentVideoSlug)[0];
        const newVideo = videoArr.filter((item) => item.dataset.videoSlug === newVideoSlug)[0];
        const oldMenuItem = menuLinksArr.filter(
            (item) => item.dataset.videoSlug === currentVideoSlug
        )[0];
        const newMenuItem = menuLinksArr.filter(
            (item) => item.dataset.videoSlug === newVideoSlug
        )[0];
        if (oldVideo) {
            oldVideo.classList.add('nav__video--hidden');
            oldVideo.pause();
            oldVideo.currentTime = 0;
        }
        if (newVideo) {
            newVideo.classList.remove('nav__video--hidden');
            newVideo.play();
        }
        newMenuItem.classList.add('highlighted');
        // needs a conditional because default vimeo ID does not have corresponding <li>
        if (oldMenuItem) {
            oldMenuItem.classList.remove('highlighted');
        }
        currentVideoSlug = newVideoSlug;
    }
};

// add data attributes to hover links
menuItemsArr.map((item, i) => {
    const anchorLink = item.children[0];
    anchorLink.setAttribute('data-video-slug', `menu-${i}`);
});
// Do not load Vimeo iframes if a user is on mobile
if (window.innerWidth > 600) {
    menu.addEventListener('mouseover', changeVideo);
    menu.addEventListener('focus', changeVideo, true);
}

determineCurrentPage();
